module.exports = __webpack_public_path__ + "img/ico_prod_type_box.686821c.svg";